import React from "react";

const LINK_CLASS = "px-2 text-primary fw-bold text-decoration-underline";

function normalizeLabel(children, defaultLabel) {
  if (children == null || children === "") return defaultLabel;
  if (typeof children === "string" || typeof children === "number") return String(children);
  if (Array.isArray(children)) {
    const text = children
      .map((child) => (typeof child === "string" || typeof child === "number" ? String(child) : ""))
      .join("")
      .trim();
    return text || defaultLabel;
  }
  return defaultLabel;
}

function extractHrefAndLabel(value, defaultLabel) {
  if (value == null || value === "") return null;

  if (typeof value === "string") {
    if (/^https?:\/\//i.test(value)) {
      return { href: value, label: defaultLabel };
    }
    return null;
  }

  if (React.isValidElement(value) && value.props?.href) {
    return {
      href: value.props.href,
      label: normalizeLabel(value.props.children, defaultLabel),
    };
  }

  if (typeof value === "object") {
    const href = value.props?.href ?? value.href ?? value.url;
    if (href) {
      const label = normalizeLabel(value.props?.children ?? value.children, defaultLabel);
      return { href, label };
    }
  }

  return null;
}

/** Renders a document link, passes through strings like "Not Uploaded", otherwise shows Not Uploaded. */
export function renderDpatDocumentLink(value, defaultLabel = "View Document") {
  const extracted = extractHrefAndLabel(value, defaultLabel);
  if (extracted) {
    return (
      <a
        href={extracted.href}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASS}
      >
        {extracted.label}
      </a>
    );
  }

  if (typeof value === "string" && value.trim()) {
    return value;
  }

  return "Not Uploaded";
}

export function mapRowDocumentLinks(row, linkKeys, defaultLabel = "View Document") {
  const mapped = { ...row };
  linkKeys.forEach((key) => {
    mapped[key] = renderDpatDocumentLink(row[key], defaultLabel);
  });
  return mapped;
}

export function mapRowsDocumentLinks(rows, linkKeys, defaultLabel = "View Document") {
  if (!rows) return [];
  return rows.map((row) => mapRowDocumentLinks(row, linkKeys, defaultLabel));
}
